module.exports = __webpack_public_path__ + "static/bro2-a7aabbc782cf70ecdcefa39421a36e49.jpg";